import { ZfBox, ZfTextButton } from '@zafire/react';
import type { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import type { ExtendedSeriesOptionType } from '../../../interfaces/projection';
import { MonteCarloChartSubHeader } from './MonteCarloChartSubHeader';

interface IProps {
    chart?: Highcharts.Chart;
    totalSelectedBankableAssets: number;
    seriesData?: ExtendedSeriesOptionType[];
    isDrawerOpen: boolean;
    buttonDisabled: boolean;
    onOpenDrawer: () => void;
}

export const MonteCarloChartSubHeaderWrapper: FunctionComponent<IProps> = ({
    chart,
    totalSelectedBankableAssets,
    seriesData,
    isDrawerOpen,
    buttonDisabled,
    onOpenDrawer,
}) => {
    const { t } = useTranslation();

    return (
        <ZfBox style={{ position: 'relative', display: 'flex', width: '100%', height: '100%' }}>
            <ZfBox
                className="projection-screen__subtitle"
                style={{
                    flexGrow: 1,
                    transition: 'margin 225ms cubic-bezier(0.4, 0, 0.6, 1) 0ms',
                    marginRight: 0,
                    ...(isDrawerOpen && {
                        transition: 'margin 195ms cubic-bezier(0.0, 0, 0.2, 1) 0ms',
                    }),
                }}
            >
                <MonteCarloChartSubHeader chart={chart} totalSelectedBankableAssets={totalSelectedBankableAssets} seriesData={seriesData} />
                <ZfTextButton
                    className="projection-screen__simulation-btn"
                    size="medium"
                    onClick={onOpenDrawer}
                    hierarchy="secondary"
                    disabled={buttonDisabled}
                >
                    {t('simulationSettings')}
                </ZfTextButton>
            </ZfBox>
        </ZfBox>
    );
};
